import { Injector } from "@angular/core";
import { INotificationSendParams } from "./notification-send-param";
import { AnyCatcher } from "rxjs/internal/AnyCatcher";

export abstract class NotificationAbstract {

    abstract type           : string;
    title                   : string;
    body                    : string;

    constructor(){
        this.title = "";
        this.body = "";
    }

    public abstract send(NotificationSendParams : INotificationSendParams)
    public abstract received()
    public abstract perform();

}